import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Invite a friend',
    share: 'Send invite',
    copyLink: 'Copy invite link',
    copied: 'Copied!',
    linkLabel: 'Your invite link',
    copyFailed: 'The browser blocked the clipboard. Select the link above and copy it by hand.',
  },
  ru: {
    title: 'Пригласить друга',
    share: 'Отправить приглашение',
    copyLink: 'Скопировать ссылку',
    copied: 'Скопировано!',
    linkLabel: 'Твоя ссылка-приглашение',
    copyFailed: 'Браузер не дал доступ к буферу обмена. Выдели ссылку выше и скопируй вручную.',
  },
  uz: {
    title: 'Doʻstni taklif qilish',
    share: 'Taklif yuborish',
    copyLink: 'Havolani nusxalash',
    copied: 'Nusxalandi!',
    linkLabel: 'Sening taklif havolang',
    copyFailed: 'Brauzer clipboardga ruxsat bermadi. Yuqoridagi havolani belgilab, qoʻlda nusxala.',
  },
  fa: {
    title: 'دوستت را دعوت کن',
    share: 'ارسال دعوت',
    copyLink: 'کپی لینک دعوت',
    copied: 'کپی شد!',
    linkLabel: 'لینک دعوت تو',
    copyFailed: 'مرورگر اجازه کپی نداد. لینک بالا را انتخاب کن و دستی کپی کن.',
  },
  pt: {
    title: 'Convidar um amigo',
    share: 'Enviar convite',
    copyLink: 'Copiar link',
    copied: 'Copiado!',
    linkLabel: 'Seu link de convite',
    copyFailed: 'O navegador bloqueou a área de transferência. Selecione o link acima e copie manualmente.',
  },
  tr: {
    title: 'Arkadaşını davet et',
    share: 'Davet gönder',
    copyLink: 'Linki kopyala',
    copied: 'Kopyalandı!',
    linkLabel: 'Davet linkin',
    copyFailed: 'Tarayıcı panoya erişime izin vermedi. Yukarıdaki linki seçip elle kopyala.',
  },
  uk: {
    title: 'Запросити друга',
    share: 'Надіслати запрошення',
    copyLink: 'Скопіювати посилання',
    copied: 'Скопійовано!',
    linkLabel: 'Твоє посилання-запрошення',
    copyFailed: 'Браузер не дав доступ до буфера обміну. Виділи посилання вище й скопіюй вручну.',
  },
  de: {
    title: 'Freund einladen',
    share: 'Einladung senden',
    copyLink: 'Link kopieren',
    copied: 'Kopiert!',
    linkLabel: 'Dein Einladungslink',
    copyFailed: 'Der Browser hat den Zugriff auf die Zwischenablage blockiert. Markiere den Link oben und kopiere ihn von Hand.',
  },
  es: {
    title: 'Invita a un amigo',
    share: 'Enviar invitación',
    copyLink: 'Copiar enlace de invitación',
    copied: '¡Copiado!',
    linkLabel: 'Tu enlace de invitación',
    copyFailed: 'El navegador bloqueó el portapapeles. Selecciona el enlace de arriba y cópialo a mano.',
  },
  pl: {
    title: 'Zaproś znajomego',
    share: 'Wyślij zaproszenie',
    copyLink: 'Skopiuj link z zaproszeniem',
    copied: 'Skopiowano!',
    linkLabel: 'Twój link z zaproszeniem',
    copyFailed: 'Przeglądarka zablokowała schowek. Zaznacz link powyżej i skopiuj go ręcznie.',
  },
});
